import { getCookie } from "../cookies";

export const promotionList = [
  {
    id: 1,
    titleKey: "promotion.1.3.title",
    desc: "promotion.1.3.description",
    alt: "promotion.1.3.title",
    imgSmall: "/images/referralbonus.jpg",
    imgLarge: "/images/referral-banner.webp",
    promoClick: "/promotion/referral-bonus/",
    priority: 100,
    target: false
  },
  {
    id: 2,
    titleKey: "promotion.1.2.title",
    desc: "promotion.1.2.description",
    alt: "promotion.1.2.title",
    imgSmall: "/images/deposit-banner-small.jpg",
    imgLarge: "/images/deposit-banner.webp",
    promoClick: "/promotion/deposit-bonus/",
    priority: 99,
    target: false
  },
  {
    id: 3,
    titleKey: "promotion.1.title",
    desc: "promotion.1.description",
    alt: "promotion.1.title",
    imgSmall: "/images/reward-banner-small.jpg",
    imgLarge: "/images/reward-banner.webp",
    promoClick: "/promotion/reward-points/",
    priority: 98,
    target: false
  },
  // {
  //   id: 6,
  //   titleKey: "promotion.6.title.1",
  //   desc: "promotion.6.desc.1",
  //   alt: "promotion.6.title",
  //   imgSmall: "/images/promotion/DailyWins_700x450.webp",
  //   imgLarge: "/images/promotion/DailyWins_1903x550.webp",
  //   promoClick: "/promotion/daily-wins/",
  //   priority: 91,
  //   target: false
  // },
  //  {
  //    id: 7,
  //    titleKey: "promotion.7.title.1",
  //    desc: "promotion.7.desc.1",
  //    alt: "promotion.7.title",
  //    imgSmall: "/images/promotion/BetRace700x450_th.webp",
  //    imgLarge: "/images/promotion/BetRace1903x550_th.webp",
  //    promoClick: "/promotion/bng-bet-race/",
  //    priority: 84,
  //    target: false
  //  },
  // {
  //   id: 8,
  //   titleKey: "promotion.9.title.1",
  //   desc: "promotion.9.desc.1",
  //   alt: "promotion.9.title",
  //   imgSmall: "promotion.9.imageSml",
  //   imgLarge: "promotion.9.imageLrg",
  //   promoClick: "promotion.9.href",
  //   priority: 86,
  //   target: true
  // },
  {
    id: 9,
    titleKey: "promotion.11.title.1",
    desc: "promotion.11.desc.1",
    alt: "promotion.11.title",
    imgSmall: "promotion.11.imageSml",
    imgLarge: "promotion.11.imageLrg",
    promoClick: "/promotion/sbo-weekly-mission/",
    priority: 88,
    target: false
  },
  {
    //spadegaming play n win
    id: 19,
    titleKey: "promotion.19.title.1",
    desc: "promotion.19.desc.1",
    alt: "promotion.19.title",
    imgSmall: "promotion.19.imageSml",
    imgLarge: "promotion.19.imageLrg",
    promoClick: "/promotion/spadegaming-play-and-win/",
    priority: 81,
    target: false,
  },  
  {
    //spadegaming Fishing Frenzy
    id: 22,
    titleKey: "promotion.22.title.1",
    desc: "promotion.22.desc.1",
    alt: "promotion.22.title",
    imgSmall: "promotion.22.imageSml",
    imgLarge: "promotion.22.imageLrg",
    promoClick: "/promotion/fishing-frenzy/",
    priority: 80,
    target: false,
  },
  // {
  //   //spin to win
  //   id: 23,
  //   titleKey: "promotion.23.title.1",
  //   desc: "promotion.23.desc.1",
  //   alt: "promotion.23.title",
  //   imgSmall: "promotion.23.imageSml",
  //   imgLarge: "promotion.23.imageLrg",
  //   promoClick: "/promotion/spin-to-win/",
  //   priority: 79,
  //   target: false,
  // },
  // {
  //   id: 20,
  //   titleKey: "promotion.20.title.1",
  //   desc: "promotion.20.desc.1",
  //   alt: "promotion.20.title",
  //   imgSmall: "promotion.20.imageSml",
  //   imgLarge: "promotion.20.imageLrg",
  //   promoClick: "promotion.20.href",
  //   priority: 83,
  //   target: true,
  // },
  {
    id: 22,
    titleKey: "Extra Bonus, Extra Fun",
    desc: "Daily Rewards for You!",
    alt: "Extra Bonus, Extra Fun",
    imgSmall: "/images/promotion/extra-bonus-extra-fun-at-sg8-mobile.webp",
    imgLarge: "/images/promotion/extra-bonus-extra-fun-at-sg8.webp",
    promoClick: "/promotion/extra-bonus/",
    priority: 82,
    target: false,
  },
  // {
  //   id: 21,
  //   titleKey: "promotion.21.title.1",
  //   desc: "promotion.21.desc.1",
  //   alt: "promotion.21.title",
  //   imgSmall: "promotion.21.imageSml",
  //   imgLarge: "promotion.21.imageLrg",
  //   promoClick: "promotion.21.href",
  //   priority: 85,
  //   target: false,
  // },
];